import './ClientDisplayWindow.css';

const ClientDisplayWindow = ({clientInstanceData}) => {
    return (
        <div className="client-display-window">
            <p>Client Instance</p>
        </div>
    );
};

export default ClientDisplayWindow;